import Vue from 'vue';
import VueDraggable from 'vuedraggable';
import Multiselect from 'vue-multiselect';
import VueApexCharts from 'vue-apexcharts';
import upperFirst from 'lodash/upperFirst';

/**
 * Config required components
 */
const requireComponent = require.context(
  '../components',
  true,
  /[A-Z]\w+\.(vue|js)$/,
);

requireComponent.keys().forEach((fileName) => {
  const componentConfig = requireComponent(fileName);

  /**
   * Get component name in pascal case
   */
  const componentName = fileName.split('/')
    .slice(-2)
    .reduce((name, value) => {
      if (value.startsWith('components') || value === '.') {
        return name;
      }

      return name + upperFirst(value);
    }, '')
    .replace(/\.\w+$/, '');

  /**
   * Register new components
   */
  Vue.component(
    componentName,
    /**
     * Verify if the component has 'export default' else use root module
     */
    componentConfig.default || componentConfig,
  );
});

Vue.component('Apexchart', VueApexCharts);
Vue.component('Multiselect', Multiselect);
Vue.component('Draggable', VueDraggable);

// Integrations
Vue.component('Whatsapp', require('../components/whatsapp/Whatsapp').default);
Vue.component('Automation', require('../components/automation/Automation').default);
